(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dtcc-in-the-wild"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-booth-order]').forEach(grid => {
    const cards = [...grid.querySelectorAll('[data-date]')];
    const recent = grid.dataset.boothOrder === 'recent';
    cards.sort((a, b) => recent ? b.dataset.date.localeCompare(a.dataset.date) : a.dataset.date.localeCompare(b.dataset.date));
    cards.forEach((card, index) => {
      grid.appendChild(card);
      if (recent && index >= 2) card.hidden = true;
    });
  });

  document.querySelectorAll('[data-wild-map]').forEach(canvas => {
    const stage = canvas.querySelector('.dtcc-wild__map-stage');
    const layer = canvas.querySelector('.dtcc-wild__map-clusters');
    const controls = canvas.nextElementSibling;
    const slider = controls.querySelector('[data-map-zoom]');
    const output = controls.querySelector('[data-map-zoom-value]');
    const reset = controls.querySelector('[data-map-reset]');
    const southeast = controls.querySelector('[data-map-southeast]');
    const pins = [...stage.querySelectorAll('.dtcc-wild__map-pin')];
    let zoom = 1;
    let focusX = .5;
    let focusY = .5;
    let offsetX = 0;
    let offsetY = 0;
    const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

    function render() {
      const w = canvas.clientWidth;
      const h = canvas.clientHeight;
      if (!w || !h) return;
      offsetX = clamp(w / 2 - focusX * zoom * w, w * (1 - zoom), 0);
      offsetY = clamp(h / 2 - focusY * zoom * h, h * (1 - zoom), 0);
      stage.style.transform = 'translate(' + offsetX + 'px,' + offsetY + 'px) scale(' + zoom + ')';
      const mobile = window.matchMedia('(max-width: 650px)').matches;
      pins.forEach(pin => {
        pin.hidden = false;
        pin.style.width = (mobile ? 38 : 44) / zoom + 'px';
        pin.style.height = (mobile ? 43 : 50) / zoom + 'px';
      });
      layer.replaceChildren();
      const points = pins.map(pin => ({
        pin,
        worldX: parseFloat(pin.dataset.mapX) / 100,
        worldY: parseFloat(pin.dataset.mapY) / 100
      })).filter(point => Number.isFinite(point.worldX) && Number.isFinite(point.worldY));
      points.forEach(point => {
        point.x = offsetX + point.worldX * w * zoom;
        point.y = offsetY + point.worldY * h * zoom;
      });
      const parent = points.map((_, i) => i);
      const root = i => {
        while (parent[i] !== i) i = parent[i] = parent[parent[i]];
        return i;
      };
      for (let i = 0; i < points.length; i++) {
        for (let j = i + 1; j < points.length; j++) {
          if (Math.hypot(points[i].x - points[j].x, points[i].y - points[j].y) < (mobile ? 36 : 42)) parent[root(j)] = root(i);
        }
      }
      const groups = new Map();
      points.forEach((point, i) => {
        const key = root(i);
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(point);
      });
      groups.forEach(group => {
        if (group.length < 2) return;
        group.forEach(point => point.pin.hidden = true);
        const x = group.reduce((sum, point) => sum + point.x, 0) / group.length;
        const y = group.reduce((sum, point) => sum + point.y, 0) / group.length;
        const bubble = document.createElement('button');
        bubble.type = 'button';
        bubble.className = 'dtcc-wild__map-cluster';
        bubble.textContent = group.length;
        bubble.setAttribute('aria-label', group.length + ' nearby locations. Zoom in or show list.');
        bubble.style.left = x + 'px';
        bubble.style.top = y + 'px';
        bubble.addEventListener('click', () => {
          if (zoom < 5) {
            focusX = group.reduce((sum, point) => sum + point.worldX, 0) / group.length;
            focusY = group.reduce((sum, point) => sum + point.worldY, 0) / group.length;
            zoom = Math.min(5, Math.max(zoom + 1, zoom * 1.8));
            render();
            return;
          }
          const existing = layer.querySelector('.dtcc-wild__map-menu');
          if (existing) existing.remove();
          const menu = document.createElement('div');
          menu.className = 'dtcc-wild__map-menu';
          menu.style.left = clamp(x - 100, 8, w - 228) + 'px';
          menu.style.top = clamp(y + 22, 8, h - 110) + 'px';
          const title = document.createElement('strong');
          title.textContent = 'Choose a place';
          menu.appendChild(title);
          group.forEach(point => {
            const link = document.createElement('a');
            link.href = point.pin.getAttribute('href');
            link.textContent = point.pin.dataset.mapLabel;
            menu.appendChild(link);
          });
          layer.appendChild(menu);
        });
        layer.appendChild(bubble);
      });
      slider.value = zoom;
      output.value = zoom.toFixed(zoom % 1 ? 1 : 0) + '×';
      reset.setAttribute('aria-pressed', String(zoom === 1));
      southeast.setAttribute('aria-pressed', String(zoom >= 2.9 && Math.abs(focusX - .7) < .02 && Math.abs(focusY - .83) < .02));
    }
    reset.addEventListener('click', () => { zoom = 1; focusX = .5; focusY = .5; render(); });
    southeast.addEventListener('click', () => { zoom = 3; focusX = .7; focusY = .83; render(); });
    slider.addEventListener('input', () => { zoom = parseFloat(slider.value); render(); });
    canvas.addEventListener('click', event => {
      if (event.target.closest('a,button,.dtcc-wild__map-menu')) return;
      const box = canvas.getBoundingClientRect();
      focusX = clamp((event.clientX - box.left - offsetX) / (box.width * zoom), 0, 1);
      focusY = clamp((event.clientY - box.top - offsetY) / (box.height * zoom), 0, 1);
      if (zoom === 1) zoom = 2;
      render();
    });
    if (window.ResizeObserver) new ResizeObserver(render).observe(canvas);
    else window.addEventListener('resize', render);
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtcc-metaobject-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dtcc-hero')) customElements.define('dtcc-hero', class extends HTMLElement {
    connectedCallback(){this.slides=[...this.querySelectorAll('.dtcc-hero__slide')].sort((a,b)=>Number(a.dataset.order)-Number(b.dataset.order));this.slides.forEach(s=>this.querySelector('.dtcc-hero__track').appendChild(s));this.index=0;this.dots=this.querySelector('.dtcc-hero__dots');this.slides.forEach((_,i)=>{if(!this.dots)return;const b=document.createElement('button');b.type='button';b.className='dtcc-hero__dot';b.setAttribute('aria-label',`Show slide ${i+1}`);b.addEventListener('click',()=>this.show(i));this.dots.appendChild(b)});this.querySelector('.dtcc-hero__arrow--prev')?.addEventListener('click',e=>{e.preventDefault();this.show(this.index-1)});this.querySelector('.dtcc-hero__arrow--next')?.addEventListener('click',e=>{e.preventDefault();this.show(this.index+1)});this.show(0);if(this.dataset.autoplay==='true'&&this.slides.length>1)this.timer=setInterval(()=>this.show(this.index+1),Number(this.dataset.delay)||5000)}
    disconnectedCallback(){clearInterval(this.timer)}
    show(i){this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((s,n)=>s.classList.toggle('is-active',n===this.index));[...(this.dots?.children||[])].forEach((d,n)=>d.classList.toggle('is-active',n===this.index))}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
